<template>
  <v-card outlined>
    <v-card-title class="pb-0">
      <strong>{{ $t('texts.applicationDetails') }}</strong>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-container class="pa-0 ma-0">
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.workplace') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ application.job }}
          </v-col>
        </v-row>
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.workload') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ application | formatJobWorkload}}%
          </v-col>
        </v-row>
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.company.label') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ application.company }}, {{ application.place }}
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-divider/>
    <v-card-title class="pb-0">
      <strong>{{ $t('texts.userData') }}</strong>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-container class="pa-0 ma-0">
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.salutation') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ authUser.sex === 1 ? $t('texts.salutationMr') : $t('texts.salutationMrs') }}
            {{ authUser.first_name }} {{ authUser.last_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.address') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ authUser.street }} {{ authUser.street_number }}<br>
            {{ authUser.zip }} {{ authUser.place }}<br>
            {{ getCountryName(authUser.country) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.birthday') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ authUser.date_of_birth | formatDateMedium }}
          </v-col>
        </v-row>
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.nationality') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ getCountryName(authUser.nationality) }}
          </v-col>
        </v-row>
        <v-row v-if="authUser.nationality !== 'CH'">
          <v-col xs5 :sm="4">
            {{ $t(`texts.residencePermit.label`) }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ $t(`texts.residencePermit.${authUser.residence_permit }`) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.phone') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ authUser.phone }}
          </v-col>
        </v-row>
        <v-row>
          <v-col xs5 :sm="4">
            {{ $t('texts.email') }}
          </v-col>
          <v-col xs7 :sm="8">
            {{ authUser.email }}
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-divider/>
    <template v-if="checkApplicationLetter || checkApplicationLetterLength">
      <v-alert type="error" :value="checkApplicationLetter" class="mb-0">
        {{ $t('texts.attentionNoLetter') }}
      </v-alert>
      <v-alert type="warning" :value="!checkApplicationLetter && checkApplicationLetterLength" class="mb-0">
        {{ $t('texts.attentionShortLetter') }}
      </v-alert>
    </template>
    <v-card-title class="pb-0">
      <strong>{{ $t('texts.applicationLetter') }}</strong>
    </v-card-title>
    <v-card-text
      class="pt-0"
      v-html="application.application_letter"
    />
  </v-card>
</template>

<script>
export default {
  props: {
    application: {
      type: Object,
    },
    authUser: {
      type: Object,
    },
    countries: {
      type: Array,
    },
  },
  computed: {
    checkApplicationLetter() {
      return this.application.application_letter === null || this.application.application_letter.length < 2;
    },
    checkApplicationLetterLength() {
      return this.application.application_letter === null || this.application.application_letter.length < 100;
    },
  },
  methods: {
    getCountryName(key) {
      const selectedCountry = this.countries.find((country) => country.iso === key);
      return selectedCountry.name;
    },
  },
};
</script>
